import { render } from "./HomeBookingForm.vue?vue&type=template&id=23e985a6"
import script from "./HomeBookingForm.vue?vue&type=script&lang=js"
export * from "./HomeBookingForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__